import { parseCookies } from '../lib/cookie/parser';
import { createUserProfile } from '../lib/cookie/user/profile';

export const getUserProfile = (): UserProfile => {
  const cookies = parseCookies();
  return createUserProfile(cookies);
};
